import React from 'react';

import SectionMessage from '@atlaskit/section-message';
import { token } from '@atlaskit/tokens';
import { useDebugConnectionStatus } from 'src/services/debugLogs';

import { textifyError } from 'src/lib/error';

const Status = () => {
  const { status, connectedServicesCount, expectedServicesCount, error } = useDebugConnectionStatus();
  let state = { message: 'disconnected', color: token('color.text.danger', '#DE350B') };
  if (status === 'connecting') state = { message: `connecting...`, color: token('color.text.warning', '#b36200') };
  if (status === 'connected') state = { message: `connected (${connectedServicesCount}/${expectedServicesCount} service instances)`, color: token('color.text.success', '#00875A') };
  if (status === 'error') state = { message: `error: ${textifyError(error)}`, color: token('color.text.danger', '#DE350B') };

  return (
    <SectionMessage title="New logs are only captured when this tab is open">
      Keep this <em>Debug Logs</em> tab open in a separate browser tab or window during your investigations<br/>
      And make sure it stays connected to the server:
      <div style={{ color: state.color, fontWeight: 'bold' }}>
        &#9679; {state.message}
      </div>
    </SectionMessage>
  );
};

export default Status;
